import React from "react";
import { styled, Typography } from "@mui/material";
//import theme from "../../theme/theme";

const SubtitleText = styled(Typography)(({ theme }) => ({
  fontFamily: theme.typography,
  color: "#263057",
  marginLeft: "3rem",
  marginRight: "1rem",
  marginBottom: "1rem",
  fontSize: "14px",
}));


const Subtitle = ({ children }) => {
  return <SubtitleText>{children}</SubtitleText>;
};

export default Subtitle;
